import { Component,
         AfterViewInit,
         EventEmitter,
         Output}             from '@angular/core';
import { ISortableFilter,
         SortableFilter,
         SortDirection }            from '../common/sortable-filter';
import { Globals }                  from '../common/globals';
import { MatDialog }                from '@angular/material';
import { SettingService }           from '../shared/setting.service';
import { TableColumn, TableColumnType } from '../common/table-column';
import { SettingDialogComponent } from '../setting-dialog/setting-dialog.component';
import { SavingDialogComponent } from '../common/saving-dialog.component';


@Component({
  selector: 'sa-setting-list',
  template: require('./setting-list.component.html'),
  styles: [require('./setting-list.component.scss')]
})
export class SettingListComponent {

  public settings: Array<any> = [];

  @Output() columns: Array<TableColumn>;
  @Output() filter = new SortableFilter('name', SortDirection.desc);
  @Output() performSearch = new EventEmitter();

  public getDataCallback: Function;
  public dataPageCallback: Function;

  public displayedColumns: string[] = ['name', 'value'];

  constructor(
    private apiService: SettingService,
    private dialog: MatDialog,
    private globals: Globals
  ) {
    this.apiService = apiService;
    this.getDataCallback = this.getData.bind(this);
    this.dataPageCallback = this.getDataPage.bind(this);

    this.columns = [
      new TableColumn(TableColumnType.Text, 'name', 'Klíč', 100),
      new TableColumn(TableColumnType.Text, 'value', 'Hodnota', 500)
    ];
  }

  private getData(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  public search() {
    this.performSearch.emit(this.filter);
  }

  private getDataPage(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  public addNew() {
    let dialogRef = this.dialog.open(SettingDialogComponent, {disableClose: true});
    dialogRef.componentInstance.model = { name: '', value: '' };
    dialogRef.componentInstance.newItem = true;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(res => {
            cloakRef.close();
            this.search();
          });
      }
    });
  }

  public editItem(model) {
    let dialogRef = this.dialog.open(SettingDialogComponent);
    dialogRef.componentInstance.model = model;
    dialogRef.componentInstance.newItem = false;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.updateItem(dialogRef.componentInstance.model.name, dialogRef.componentInstance.model)
          .subscribe(res => {
            cloakRef.close();
            this.search();
          });
      } else if (result === 'delete') {
        let cloakRef = this.dialog.open(SavingDialogComponent);
        this.apiService.deleteItem(dialogRef.componentInstance.model.name)
          .subscribe(
            _ => {
              cloakRef.close();
              this.search();
          },
            _ => {
              cloakRef.close();
              window.alert('Vybraná položka nemohla být odstraněna.');
            }
          );
      } else {
        this.search();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/setting-list/setting-list.component.ts